// Global flag to prevent multiple executions
if (!window.__premiumKitScriptLoaded) {
  window.__premiumKitScriptLoaded = true;

  document.addEventListener("DOMContentLoaded", function () {
    try {
      if (typeof Elixir_ProductFormExists !== "function" || !Elixir_ProductFormExists()) return;
      // Find all premium-attachment-kit instances on the page
      const kitWrappers = document.querySelectorAll(".premium-attachment-kit");

      if (!kitWrappers.length) {
        console.log("No premium-attachment-kit found, exiting");
        return;
      }

      // Process each kit wrapper independently
      kitWrappers.forEach((kitWrapper, wrapperIndex) => {
        // Check if this wrapper was already processed
        if (kitWrapper.hasAttribute("data-kit-processed")) {
          console.log("Wrapper already processed, skipping");
          return;
        }

        // Mark wrapper as processed immediately
        kitWrapper.setAttribute("data-kit-processed", "true");

        const productForm = typeof Elixir_GetProductForm === "function" ? Elixir_GetProductForm() : null;

        if (!productForm) {
          console.log("No product form found for this kit, skipping");
          return;
        }

        // Get kit items ONLY from this specific wrapper (not all kit items on the page)
        const kitItems = kitWrapper.querySelectorAll(".kit-item");

        if (!kitItems.length) {
          console.log("No kit items in this wrapper, skipping");
          return;
        }

        // Get the main product ID from the controller; skip if unavailable
        if (typeof Elixir_GetProductFormVariantId !== 'function') return;
        const mainProductId = Elixir_GetProductFormVariantId();
        if (!mainProductId) return;
        const relyOnProductId = kitWrapper.getAttribute("data-rely-on-product-id") || mainProductId;

        const container = document.createElement("div");
        container.classList.add("premium-kit--products");
        container.classList.add("premium-kit--products-" + wrapperIndex);
        let hasContent = false;

        // Start index after existing items to avoid conflicts with quantity breaks
        const existingItems = productForm.querySelectorAll('input[name*="items["][name*="][id]"]');
        let index = existingItems.length + 1;

        // Track unique product IDs to prevent duplicates
        const addedProductIds = new Set();

        kitItems.forEach((_item, itemIndex) => {
          const id = _item.getAttribute("data-product-id");
          const available = _item.getAttribute("data-available") !== "false";

          if (id && available && !addedProductIds.has(id)) {
            addedProductIds.add(id);

            // Variant ID
            const inputId = document.createElement("input");
            inputId.type = "hidden";
            inputId.name = `items[${index}][id]`;
            inputId.value = id;
            inputId.classList.add("product-variant-id");
            inputId.classList.add("premium-kit-free-gift-id");

            // Quantity
            const inputQuantity = document.createElement("input");
            inputQuantity.type = "hidden";
            inputQuantity.name = `items[${index}][quantity]`;
            inputQuantity.value = 1;
            inputQuantity.classList.add("product-variant-id");

            // Line item property: Mark as free gift
            const inputIsFreeGift = document.createElement("input");
            inputIsFreeGift.type = "hidden";
            inputIsFreeGift.name = `items[${index}][properties][_is_free_gift]`;
            inputIsFreeGift.value = "true";

            // Line item property: Link to main product
            const inputLinkedTo = document.createElement("input");
            inputLinkedTo.type = "hidden";
            inputLinkedTo.name = `items[${index}][properties][_linked_to_product]`;
            inputLinkedTo.value = relyOnProductId;

            container.appendChild(inputId);
            container.appendChild(inputQuantity);
            container.appendChild(inputIsFreeGift);
            container.appendChild(inputLinkedTo);

            hasContent = true;
            index++;
          }
        });

        if (hasContent) {
          productForm.appendChild(container);
        }

        // ELIXIR PATCH 2026-09-13 (tier-gated gift, R-OFFER-13). Stock, the gift rode every order. With
        // gift_min_quantity > 1 the kit's inputs are DISABLED -- FormData skips disabled
        // controls -- until the selected quantity-break tier holds that many units. The
        // ladder clicks its preselected tier before this script runs, so the initial
        // state is read off the DOM; every later change arrives as quantity_break:changed.
        const minQty = parseInt(kitWrapper.getAttribute("data-gift-min-qty") || "1", 10) || 1;
        if (hasContent && minQty > 1) {
          const gate = function (qty) {
            const on = (parseInt(qty, 10) || 0) >= minQty;
            container.querySelectorAll("input").forEach(function (inp) { inp.disabled = !on; });
            kitWrapper.classList.toggle("premium-attachment-kit--locked", !on);
            kitWrapper.setAttribute("data-gift-unlocked", on ? "true" : "false");
          };
          const selected = document.querySelector(".quantity-break-option.selected input");
          gate(selected ? selected.value : (productForm.getAttribute("data-quantity") || 1));
          document.addEventListener("quantity_break:changed", function (e) {
            gate(e && e.detail ? e.detail.quantity : 0);
          });
        }
      });
    } catch (_err) {
      console.log("Error on premium kit script", _err);
    }
  });
}


// ELIXIR PATCH 2026-09-13 (gift line cap, R-OFFER-13). A free-gift line holds ONE unit. The drawer's stepper
// already stops at 1 (max="1" in snippets/cart-items.liquid); this guard catches what the
// stepper cannot -- a second Add to cart merging the gift into a line of 2. After any cart
// update, and whenever the drawer re-renders, every `_is_free_gift` line above 1 is set
// back to 1 and the theme's own cart-update event re-renders the drawer. This file loads
// on every page (layout/theme.liquid), so every page carries the guard.
(function () {
  if (window.__elixirGiftCap) return;
  window.__elixirGiftCap = true;
  var busy = false, timer = null;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  function capGifts() {
    if (busy) return;
    busy = true;
    fetch(root + "cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // ONE UNIT PER GIFT PRODUCT, counted across lines (measured 2026-09-13): a gift
        // stepped to 2 does not stay one line -- Shopify splits it into a $0 unit under the
        // BxGy and a charged unit, each a line of 1 with its own key. Keep the cheapest
        // line at 1 and set every other line of that gift to 0.
        var updates = {}, n = 0, by = {};
        (cart.items || []).forEach(function (it) {
          if (it.properties && it.properties._is_free_gift === "true") {
            (by[it.variant_id] = by[it.variant_id] || []).push(it);
          }
        });
        Object.keys(by).forEach(function (v) {
          var lines = by[v], total = 0;
          lines.forEach(function (it) { total += it.quantity; });
          if (total <= 1) return;
          lines.sort(function (a, b) { return a.final_line_price - b.final_line_price; });
          lines.forEach(function (it, i) {
            var want = i === 0 ? 1 : 0;
            if (it.quantity !== want) { updates[it.key] = want; n++; }
          });
        });
        if (!n) return;
        return fetch(root + "cart/update.js", {
          method: "POST", headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ updates: updates })
        }).then(function () {
          if (window.publish && window.PUB_SUB_EVENTS) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: "elixir-gift-cap" });
          }
        });
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }
  function soon() { clearTimeout(timer); timer = setTimeout(capGifts, 400); }
  document.addEventListener("DOMContentLoaded", soon);
  if (window.subscribe && window.PUB_SUB_EVENTS) {
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function (e) {
      if (!e || e.source !== "elixir-gift-cap") soon();
    });
  }
  document.addEventListener("DOMContentLoaded", function () {
    var drawer = document.querySelector("cart-drawer");
    if (drawer && window.MutationObserver) {
      new MutationObserver(soon).observe(drawer, { childList: true, subtree: true });
    }
  });
})();
